export function validURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
}

export const isEmpty = (obj) => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const generateID = () => {
  return Math.random().toString(36).substr(2, 9);
};

// Returns an array of all workouts specific to a station
export const getStationData = (allActivities, stNr) => {
  if (allActivities) {
    const specificStationData =
      // get every day with a workout at the requested station
      allActivities
        .filter((workoutDay) => {
          return workoutDay.exercises.some((exercise) => {
            return exercise.stNr === stNr.toString();
          });
        })
        // Return workouts matching with stNr
        .map((workoutDay) => {
          return {
            date: workoutDay.date,
            exercises: workoutDay.exercises.filter((exercise) => {
              return exercise.stNr === stNr.toString();
            }),
          };
        });

    return specificStationData;
  }
};

export const zeroPad = (num, places) => {
  if (!num) return "01";
  return String(num).padStart(places, "0");
};

export const getGermanDate = (date = new Date(), withWeekDay = false) => {
  const dateString = new Date(date).toLocaleDateString("de-DE", {
    ...(withWeekDay && { weekday: "short" }),
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return dateString;
};
